import { render, staticRenderFns } from "./tabsindex.vue?vue&type=template&id=36a5ec9d&scoped=true"
import script from "./tabsindex.vue?vue&type=script&lang=js"
export * from "./tabsindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a5ec9d",
  null
  
)

export default component.exports